import { useContext, useState, useEffect } from "react"
import useLoading from "../../hooks/useLoading"
import { PublicProfileRequests } from "../../api/public.service"
import { useAuthenticatedUser } from "../../hooks/useAuthenticatedUser"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

export const BBHC20visibilityBanner = () => {
  const { startLoading, stopLoading } = useLoading()
  const { user } = useContext(UserCtx)
  const { toast } = useToast()
  const [coachPublicProfileData, setCoachPublicProfileData] = useState<any>({})
  const [newsletter, setNewsletter] = useState({
    title: "",
    subheading: "",
    enabled: false,
  })

  const authenticatedUser = useAuthenticatedUser(user)

  const getCoachPublicProfile = async () => {
    startLoading()
    await PublicProfileRequests.getCoachPublicProfile({
      endpoint_slug: user.coachProfile.endpoint_slug,
    })
      .then((data) => {
        if (data.coach_public_profile) {
          setCoachPublicProfileData(data.coach_public_profile)
          if (data.coach_public_profile.newsletter_opt_in_enabled) {
            setNewsletter({
              enabled: true,
              title: data.coach_public_profile.newsletter_title || "",
              subheading: data.coach_public_profile.newsletter_subheading || "",
            })
          } else {
            setNewsletter({
              enabled: false,
              title: "",
              subheading: "",
            })
          }
        } else {
          setCoachPublicProfileData(null)
        }
      })
      .catch((ex) => {
        toast.error(ex.response.data.message)
      })
      .finally(() => {
        stopLoading()
      })
  }

  useEffect(() => {
    if (authenticatedUser && user.isCoach) {
      getCoachPublicProfile()
    }
  }, [])

  if (
    authenticatedUser &&
    coachPublicProfileData?.marketplace_visibility === true
  )
    return null
  return (
    <>
      <section className="subscription-cta-gradient relative py-4 pr-4">
        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-32 justify-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left">
            <span className="text-lg lg:text-base">
              <span className="font-bold">Zoee Zone:</span> {"\u{1F389}"} You
              now have access to publish your Zoee website and appear in the
              public{" "}
              <strong>
                <a href="/coach/contacts">Coach Directory</a>
              </strong>{" "}
              and{" "}
              <strong>
                <a href="/providers">Marketplace</a>
              </strong>
              . To get listed and attract new clients, follow step 5 in{" "}
              <a
                href="https://intercom.help/zoee/en/articles/8121449-how-do-i-set-up-my-zoee-website"
                className="underline"
              >
                this guide!
              </a>
            </span>
          </div>
        </div>
      </section>
    </>
  )
}
